<template>
  <div>
    <h1>Settings</h1>
    <p>Coming soon ...</p>
  </div>
</template>
<script>
export default {
  components: {},
  mounted(){},
  methods: {},
  data() {
    return {}
  },
  computed: {
  },
  filters: {
  },
}
</script>